export function getView(value) {
  return value === 'div'
}
